import { responseHandleService } from './ResponseHandleService';
import AuthenticationService from './AuthenticationService';
import axios from 'axios';
import { appendAttachment } from '../utils/FormDataUtils';

export const publicDebatesService = {
  getAll,
  createOrUpdate,
  deleteDebate,
  search
};
const requestOptions = {
  method: 'GET',
  headers: {
    Accept: 'application/json',
    'Content-type': 'application/json'
  }
};

function getAll(pageNumber) {
  let url = `${
    process.env.REACT_APP_API_URL
  }/api/public_debates/?page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(url, requestOptions)
    .then(responseHandleService.handleResponse)
    .catch(error => console.log(error));
}
function search(searchDebate, pageNumber) {
  let searchUrl = `${
    process.env.REACT_APP_API_URL
  }/api/public_debates/search?title=${searchDebate.title}&archiveYear=${
    searchDebate.archiveYear
  }&page[number]=${pageNumber ? pageNumber : 1}`;

  return fetch(searchUrl, requestOptions).then(
    responseHandleService.handleResponse
  );
}
function createOrUpdate(newDebate) {
  const requestOptions = {
    method: newDebate.id ? 'PUT' : 'POST',
    headers: {
      Accept: 'application/json'
    },
    body: createBodyRequest(newDebate)
  };

  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptions.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }

  const url = `${process.env.REACT_APP_API_URL}/api/public_debates${
    newDebate.id ? `/${newDebate.id}` : ''
  }`;

  return fetch(url, requestOptions).then(responseHandleService.handleResponse);
}

function createBodyRequest(debate) {
  let formData = new FormData();

  formData.append('public_debate[title]', debate.title);
  formData.append('public_debate[add_date]', debate.date);
  formData.append('public_debate[responsable]', debate.responsable);

  const documentAnnouncement = debate.document_announcement;

  appendAttachment(
    formData,
    `public_debate[document_announcement]`,
    documentAnnouncement
  );
  const documentProcedure = debate.document_procedure;

  appendAttachment(
    formData,
    `public_debate[document_procedure]`,
    documentProcedure
  );
  const documentMinute = debate.document_minute;

  appendAttachment(formData, `public_debate[document_minute]`, documentMinute);
  const documentCentralizator = debate.document_centralizator;

  appendAttachment(
    formData,
    `public_debate[document_centralizator]`,
    documentCentralizator
  );

  return formData;
}
function deleteDebate(debateId) {
  const requestOptionsDelete = {
    headers: {
      Accept: 'application/json'
    }
  };
  this.authentication = new AuthenticationService();

  if (this.authentication.loggedIn()) {
    requestOptionsDelete.headers['Authorization'] =
      'Bearer ' + this.authentication.getToken();
  }
  let url = `${process.env.REACT_APP_API_URL}/api/public_debates/${debateId}`;

  return axios.delete(url, requestOptionsDelete);
}
